import { blueColour, defaultFontNormal } from "../utils/styling";
import {
  addTableSpace,
  areSameDates,
  generateTable,
  isCurrentlySelectedYear,
} from "./utils";

import {
  formatNumber as formatNumberDisplay,
  generateSectionParagraphs,
} from "../utils/WordExportUtils";

// const getSumUnusedAllowancesBreakdown = (item, selectedPeriodEnd) => {
//   return (
//     item.used_allowances_breakdown
//       ?.filter((breakdown) =>
//         processDateJS(breakdown.utilisation_period_end).isBefore(
//           selectedPeriodEnd,
//         ),
//       )
//       ?.reduce((acc, breakdown) => acc + breakdown.amount_used, 0) ?? 0
//   );
// };

const getUnusedAllowancesBreakdownAmount = (item, selectedPeriodEnd) => {
  return formatNumberDisplay(
    item.used_allowances_breakdown?.find((breakdown) =>
      areSameDates(breakdown.utilisation_period_end, selectedPeriodEnd),
    )?.amount_used,
  );
};

const getUnusedGeneratedAmount = (
  unused_allowances_for_group,
  selectedPeriodEnd,
) => {
  return formatNumberDisplay(
    unused_allowances_for_group?.find((allowance) => {
      areSameDates(allowance?.period_end, selectedPeriodEnd);
    })?.unused_generated,
  );
};

export const generateSummaryTable = (
  unused_allowances_for_group,
  poaData,
  poaEnd,
) => {
  const columns = [
    {
      title: "Generated in Period ended",
      greyHeader: true,
      type: "date",
      metric: "period_end",
    },
    {
      title: "Unused Interest Allowance generated",
      greyHeader: true,
      type: "calculation",
      calculation: (item) =>
        isCurrentlySelectedYear(item.period_end, poaEnd)
          ? "0"
          : formatNumberDisplay(item.unused_generated),
    },
    {
      title: "Unused Interest Allowance remaining at start of period",
      type: "calculation",
      calculation: (item) =>
        poaData.apply_group_ratio_election
          ? item.gr_unused_allowance
          : item.fr_unused_allowance,
    },
    {
      title: "Unused Interest Allowance (utilised)/generated in current period",
      type: "calculation",
      calculation: (item) =>
        isCurrentlySelectedYear(item.period_end, poaEnd)
          ? getUnusedGeneratedAmount(unused_allowances_for_group, poaEnd)
          : getUnusedAllowancesBreakdownAmount(item, poaEnd),
    },
    {
      title: "Unused Interest Allowance remaining at end of period",
      type: "number",
      metric: "unused_allowance",
    },
  ];

  const table = generateTable(unused_allowances_for_group, columns);

  const paragraphs = [
    {
      segments: [
        {
          text: "[Note: In order to carry forward unused interest allowance a full interest restriction return must be submitted for each year between that in which the unused interest allowance is generated and that in which it is used.]",
          font: defaultFontNormal,
          color: blueColour,
          break: 1,
        },
      ],
    },
  ];

  const tableSection = [
    ...(table ? [addTableSpace(100), table] : []),
    ...generateSectionParagraphs(paragraphs),
  ];

  return tableSection;
};
